import React, { useRef } from "react"
import { graphql, Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import "../styles/index.scss"
import ImageFader from "../components/image-fader"
import BackgroundVideo from "../components/background-video"
import QuicklinkArrow from "../components/quicklink-arrow"

export const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
    }

    home: sanityHomepage {
      backgroundVideoUrl
      imageSlider {
        alt
        asset {
          fluid(maxWidth: 2500) {
            ...GatsbySanityImageFluid
          }
        }
      }
      overlayText
    }

    venue: sanityVenueHire {
      title
    }

    happening: sanityWhatsHappening {
      title
    }

    residentCompanies: sanityP2CompaniesPage {
      title
    }

    history: sanityHistoryOfTheArsenal {
      title
    }
  }
`

const IndexPage = ({ location, data }) => {
  const videoContainer = useRef(null)
  const site = (data || {}).site
  const home = (data || {}).home

  return (
    <Layout isInHome>
      <SEO
        location={location} description={site.description} />
      <div className="full-bleed-strip">
        {home.backgroundVideoUrl !== null ? (
          <BackgroundVideo url={home.backgroundVideoUrl} />
        ) : (
          <ImageFader images={home.imageSlider} />
        )}

        <div className="index__dark-layer" />

        <div className="strip__middle pad-sides">
          <div className="index__title">{home.overlayText}</div>
        </div>

        <div className="strip quicklinks">
          <div className="strip__middle pad-sides">
            <div className="strip quicklinks__inner">
                <Link className="quicklinks__link" to="/whats-happening">
                  {data.happening.title}&nbsp;<QuicklinkArrow />
                </Link>

                <Link className="quicklinks__link" to="/venue-hire">
                  {data.venue.title}&nbsp;<QuicklinkArrow />
                </Link>

                <Link className="quicklinks__link" to="/woolwich-stories">
                  {data.history.title}&nbsp;<QuicklinkArrow />
                </Link>
                
                <Link className="quicklinks__link" to="/about/resident-companies">
                  {data.residentCompanies.title}&nbsp;<QuicklinkArrow />
                </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
